import styled from 'styled-components';

const TopNav = styled.nav`
   display: flex;
`;

export { TopNav };

// copy into siteheader
